/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ComponentItemFinderListItemDto } from '@gh/builder-shared-data';
import { ID } from '@gh/common-shared-data';

export type ComponentItemFinderListItem = ComponentItemFinderListItemDto;

export const getComponentItemFinderListItemUniqueId = (item: ComponentItemFinderListItem) =>
  makeComponentItemFinderId(item.id, item.component);

export const getComponentItemFinderListItemId = (item: ComponentItemFinderListItem) => {
  return { id: item.id, count: item.count || 1 }
};

export const makeComponentItemFinderId = (id: ID, isComponent: boolean) => `${isComponent ? 'c' : 'i'}:${id}`;
export const makeComponentFinderId = (id: ID) => makeComponentItemFinderId(id, true);
export const makeItemFinderId = (id: ID) => makeComponentItemFinderId(id, false);

const COMPONENT_ITEM_FINDER_RE = /^(c|i):.+$/;
export const isComponentItemFinderId = (id: ID) => COMPONENT_ITEM_FINDER_RE.test(id);
